import classNames from 'classnames';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { withDefaultStyles } from '../utils/material-ui/hoc';

class Content extends React.Component<any, any> {

    public render() {
        const { classes } = this.props;
        return (
            <div style={this.props.style}>
                <main className={classNames(classes.content, {
                    [classes.contentShift]: this.props.app.drawerOpen,
                })}>
                    <div className={classes.drawerHeader} />
                    {this.props.children}
                </main>
            </div>
        );
    }

}
const mapStateToProps = (state, ownProps) => {
    return { ...state };
}

export default withDefaultStyles(withRouter(connect(
    mapStateToProps,
)(Content)));



// WEBPACK FOOTER //
// ./src/components/content.tsx